import common from "commons/languages/arabic";

const trans = {
  program_name: "DS Commerce",
  version: "3.4.12",
};

export default { ...common, ...trans };
